<template>
  <div class="face_box">
    <template v-if="edit">
      <div
        v-for="(item, index) in scoreInfo" 
        :key="index"
        @click="handleSelect(item,index)"
      >
        <i
          :class="{
            'bad': index === 0,
            'good': index === 1,
            'active': selectIndex === index
          }"
        ></i>
        <span 
          :class="{
            'activeBad': index === 0 && selectIndex === 0,
            'activeGood': index === 1 && selectIndex === 1
          }"
        >{{item.desc}}</span>
      </div>
  </template>
  <template v-else>
      <p v-if="seeRiderScore ===0">{{$t('未评价')}}</p>
      <div v-if="seeRiderScore !== 0">
          <i
            class="active"
            :class="{
              'bad': seeRiderScore === 2,
              'good': seeRiderScore === 10,
            }"
          ></i>
          <span 
            :class="{
              'activeBad': seeRiderScore === 2,
              'activeGood': seeRiderScore === 10
            }"
          >{{seeRiderDesc}}</span>
      </div>
  </template>
  </div>
</template>

<script>
export default {
  name: 'EvaluateFace',
  props: {
    scoreInfo: {
      type: Array,
      default: () => [],
    },
    // 是否是编辑
    edit: {
      type: Boolean,
      default: true,
    },
    seeRiderScore: {
      type: String,
    },
    seeRiderDesc: {
      type: String,
    },
  },
  data() {
    return {
      selectIndex: null,
    }
  },
  methods: {
    handleSelect(item, index) {
      this.selectIndex = index
      this.$emit('on-change-face', item, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.face_box {
  display: flex;
  justify-content: space-evenly;
  font-family: 'Aspira Light';
  font-weight: 200;
  div {
    display: flex;
    align-items: center;
    cursor: pointer;
    i {
      display: block;
      width: 44px;
      height: 44px;
    }
    .bad {
      background-image: url('../Evaluate/imgs/icon_3.png');
      background-size: 100% 100%;
      &.active {
        background-image: url('../Evaluate/imgs/icon_4.png');
      }
    }
    .good {
      background-image: url('../Evaluate/imgs/icon_1.png');
      background-size: 100% 100%;
      &.active {
        background-image: url('../Evaluate/imgs/icon_2.png');
      }
    }
    span {
      margin-left: 8px;
      color: #000;
      &.activeGood {
        font-family: 'Aspira Medium';
        font-weight: 500;
        @include font-color();
      }
      &.activeBad {
        font-family: 'Aspira Medium';
        color: #000;
        font-weight: 500;
      }
    }
  }
}
</style>
